// Admin/src/components/passion_ideas/PassionIdeas.js

import React, { useEffect, useState } from 'react'
import { Block, Calculator, Delete, Eye, Pencil, Search } from '../../common/Icons'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { toaster } from '../../apis/commonFunctions'
import { deleteRequest, getRequest, patchRequest, postRequest } from '../../apis/functions'
import APIS from '../../apis/routes'
import NoDataRow from '../../common/NoDataRow'
import LoadingRow from '../../common/LoadingRow'
import Button from '../../common/Button'
import Switch from "react-switch";
import ConfirmationPopup from '../../common/popups/ConfirmationPopup'
import Pagination from '../../common/Pagination'
import Search_input from '../../common/Search_input'
import moment from 'moment/moment'

export default function PassionIdeas() {
    const [all, setAll] = useState([]);
    const router = useNavigate();
    const [skip, setSkip] = useState(0);
    const [quesiton_type, setQueston] = useState(null);
    const [limit, setLimit] = useState(8);
    const [mainid, setMainId] = useState("");
    const [total, setTotal] = useState(0);
    const [params] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const search = params.get('search') || "";

    const TYPES = {
        1: "Mind",
        2: "Body",
        3: "Soul"
    };

    // ------------------ New State for Add & Edit ------------------
    // For Add Modal
    const [addIdea, setAddIdea] = useState("");
    const [addType, setAddType] = useState(1); // Default category: Mind

    // For Edit Modal
    const [editData, setEditData] = useState({
        id: "",
        type: 1,
        idea: ""
    });

    // ----------------------------------------------------------------

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getRequest(`${APIS.GET_PASSION_IDEAS}?search=${search}&skip=${skip}&limit=${limit}`);
            setLoading(false);
            if (!result.data.status) {
                toaster(result.data.message, false);
            } else {
                setAll(result.data.data);
                setTotal(result.data.total_count);
            }
        } catch (err) {
            toaster(err.message, false);
            setLoading(false);
        }
    };

    function handlePageClick({ selected }) {
        setSkip(selected * limit);
    }

    // ------------------ Add New Passion Idea ------------------
    const handleAddNew = async () => {
        try {
            const payload = {
                type: addType,
                idea: addIdea
            };
            const result = await postRequest(APIS.CREATE_PASSION_IDEA, payload);
            if (result.data.status) {
                toaster(result.data.message, true);
                // Close the add modal manually
                const closeBtn = document.getElementById("closeAddModal");
                if (closeBtn) closeBtn.click();
                // Clear form fields
                setAddIdea("");
                setAddType(1);
                // Refresh data
                fetchData();
            } else {
                toaster(result.data.message, false);
            }
        } catch (err) {
            toaster(err.message, false);
        }
    };

    // ------------------ Edit Passion Idea ------------------
    const handleEdit = (idea) => {
        setEditData({
            id: idea._id,
            type: idea.type,
            idea: idea.idea
        });
    };

    const handleUpdate = async () => {
        try {
            const payload = {
                id: editData.id,
                type: editData.type,
                idea: editData.idea
            };
            const result = await patchRequest(APIS.UPDATE_PASSION_IDEA, payload);
            if (result.data.status) {
                toaster(result.data.message, true);
                // Close the edit modal manually
                const closeBtn = document.getElementById("closeEditModal");
                if (closeBtn) closeBtn.click();
                fetchData();
            } else {
                toaster(result.data.message, false);
            }
        } catch (err) {
            toaster(err.message, false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [search, skip]);

    return (
        <>
            <div className="top_bar row align-items-center mt-3">
                <div className="col-lg-6">
                    <div className="pagetitle">
                        Passion Ideas <br />
                    </div>
                </div>
                <div className="col-lg-6 d-flex justify-content-end">
                    {/* Add Button */}
                    <button
                        className="btn btn-success me-3"
                        data-bs-toggle="modal"
                        data-bs-target="#addModal"
                    >
                        Add Passion Idea
                    </button>
                    <Search_input
                        placeholder={'Search here'}
                        search={search}
                        handleSearch={(e) => router('?search=' + (e.nativeEvent.data === " " ? search + "+" : e.target.value))}
                        icon={<Search />}
                        className='search_input'
                    />
                </div>
            </div>
            <div className="row mt-5">
                <div className="table-responsive">
                    <table className='table table-lg'>
                        <thead className='table-light'>
                            <tr>
                                <th>S.No</th>
                                <th>Text</th>
                                <th>Category</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {all.length > 0 &&
                                all.map((element, index) => (
                                    <tr key={element._id}>
                                        <td>{index + 1}</td>
                                        <td style={{ textTransform: "inherit" }}>{element.idea}</td>
                                        <td style={{ textTransform: "unset" }}>{TYPES[element.type]}</td>
                                        <td style={{ textTransform: "unset" }}>{moment(element.createdAt).format("DD MMM YYYY")}</td>
                                        <td>
                                            <div className="actions">
                                                <button
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#editModal"
                                                    onClick={() => handleEdit(element)}
                                                >
                                                    <Pencil />
                                                </button>
                                                {/* You can also add delete functionality here */}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                            {!loading && all.length <= 0 && <NoDataRow />}
                            {loading && <LoadingRow />}
                            {total > limit && (
                                <tr className='text-center'>
                                    <td colSpan={20}>
                                        <Pagination handlePageClick={handlePageClick} totalCount={total} limit={limit} />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* ------------------ Add Modal ------------------ */}
            <div
                className="modal fade"
                id="addModal"
                tabIndex="-1"
                aria-labelledby="addModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title" id="addModalLabel">
                                Add Passion Idea
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                id="closeAddModal"
                            ></button>
                        </div>

                        <div className="modal-body">
                            <div className="mb-3">
                                <label htmlFor="addTypeSelect" className="form-label">
                                    Select Category
                                </label>
                                <select
                                    className="form-select"
                                    id="addTypeSelect"
                                    value={addType}
                                    onChange={(e) => setAddType(Number(e.target.value))}
                                >
                                    <option value={1}>Mind</option>
                                    <option value={2}>Body</option>
                                    <option value={3}>Soul</option>
                                </select>
                            </div>

                            <div className="mb-3">
                                <label htmlFor="ideaInput" className="form-label">
                                    Text
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="ideaInput"
                                    value={addIdea}
                                    onChange={(e) => setAddIdea(e.target.value)}
                                    placeholder="Enter the idea text..."
                                />
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleAddNew}
                                disabled={!addIdea}
                            >
                                Save
                            </button>
                        </div>

                    </div>
                </div>
            </div>
            {/* ------------------ End Add Modal ------------------ */}

            {/* ------------------ Edit Modal ------------------ */}
            <div
                className="modal fade"
                id="editModal"
                tabIndex="-1"
                aria-labelledby="editModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title" id="editModalLabel">
                                Edit Passion Idea
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                id="closeEditModal"
                            ></button>
                        </div>

                        <div className="modal-body">
                            <div className="mb-3">
                                <label htmlFor="editTypeSelect" className="form-label">
                                    Select Category
                                </label>
                                <select
                                    className="form-select"
                                    id="editTypeSelect"
                                    value={editData.type}
                                    onChange={(e) => setEditData({ ...editData, type: Number(e.target.value) })}
                                >
                                    <option value={1}>Mind</option>
                                    <option value={2}>Body</option>
                                    <option value={3}>Soul</option>
                                </select>
                            </div>

                            <div className="mb-3">
                                <label htmlFor="editIdeaInput" className="form-label">
                                    Text
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="editIdeaInput"
                                    value={editData.idea}
                                    onChange={(e) => setEditData({ ...editData, idea: e.target.value })}
                                    placeholder="Enter the idea text..."
                                />
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleUpdate}
                                disabled={!editData.idea}
                            >
                                Update
                            </button>
                        </div>

                    </div>
                </div>
            </div>
            {/* ------------------ End Edit Modal ------------------ */}
        </>
    );
}



// // Admin\src\components\passion_ideas\PassionIdeas.js

// import React, { useEffect, useState } from 'react'
// import { Block, Calculator, Delete, Eye, Pencil, Search } from '../../common/Icons'
// import { Link, useNavigate, useSearchParams } from 'react-router-dom'
// import { toaster } from '../../apis/commonFunctions'
// import { deleteRequest, getRequest, patchRequest } from '../../apis/functions'
// import APIS from '../../apis/routes'
// import NoDataRow from '../../common/NoDataRow'
// import LoadingRow from '../../common/LoadingRow'
// import Button from '../../common/Button'
// import Switch from "react-switch";
// import ConfirmationPopup from '../../common/popups/ConfirmationPopup'
// import Pagination from '../../common/Pagination'
// import Search_input from '../../common/Search_input'
// import moment from 'moment/moment'



// export default function PassionIdeas() {
//     const [all, setAll] = useState([]);
//     const router = useNavigate()
//     const [skip, setSkip] = useState(0)
//     const [quesiton_type, setQueston] = useState(null)
//     const [limit, setLimit] = useState(8);
//     const [mainid, setMainId] = useState("");
//     const [total, setTotal] = useState(0)
//     const [params] = useSearchParams();
//     // console.log(Array.from(params.entries())," thishsishihsih")
//     const [loading, setLoading] = useState(false);
//     const search = params.get('search')

//     const TYPES = {
//         1: "Mind",
//         2: "Body",
//         3: "Soul"
//     }

//     const fetchData = async () => {
//         try {
//             setLoading(true);
//             const result = await getRequest(`${APIS.GET_PASSION_IDEAS}?search=${search ?? ""}&skip=${skip}&limit=${limit}`);
//             setLoading(false);
//             if (!result.data.status) {
//                 toaster(result.data.message, false)
//             } else {
//                 setAll(result.data.data)
//                 setTotal(result.data.total_count)

//             }
//         } catch (err) {
//             toaster(err.message, false);
//         }
//     }

//     function handlePageClick({ selected }) {
//         setSkip(selected * limit)
//     }


//     useEffect(() => {
//         fetchData();
//     }, [search, skip])

//     return (
//         <>
//             <div className="top_bar row align-items-center mt-3">
//                 <div className="col-lg-6">
//                     <div className="pagetitle">
//                         Passion Ideas <br />
//                     </div>
//                 </div>
//                 <div className="col-lg-6 text-end">
//                     {/* <Button text="Add Retailer" className="btn btn-success" onClick={() => nav("add")} /> */}
//                     <Search_input placeholder={'Search here'} search={search} handleSearch={(e) => router('?search=' + (e.nativeEvent.data === " " ? search + "+" : e.target.value))} icon={<Search />} className='search_input' />
//                 </div>
//             </div>
//             <div className="row mt-5">
//                 <div className="table-responsive">
//                     <table className='table table-lg'>
//                         <thead className='table-light'>
//                             <tr colSpan="4">
//                                 <th>S.No</th>
//                                 <th>Text</th>
//                                 <th>Category</th>
//                                 <th>Date</th>
//                                 <th>Action</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {all.length > 0
//                                 &&
//                                 all.map((element, index) => (
//                                     <tr key={element._id}>
//                                         <td>{index + 1}</td>
//                                         <td style={{ textTransform: "inherit" }}>{element.idea}</td>
//                                         <td style={{ textTransform: "unset" }}>{TYPES[element.type]}</td>
//                                         <td style={{ textTransform: "unset" }}>{moment(element.createdAt).format("DD MMM YYYY")}</td>
//                                         <td>
//                                             <div className="actions">
//                                                 {/* <button className='view p-2'>
//                                                     <Link className='view' to={'/user-management/' + element._id}>
//                                                         <Eye />
//                                                     </Link>
//                                                 </button> */}
//                                                 {/* <button className='view p-2'>
//                                                     <Link className='view' to={'/user-emi-management/' + element._id}>
//                                                         <Calculator />
//                                                     </Link>
//                                                 </button> */}
//                                                 {/* <button className='block' onClick={() => { blockUnblockUser(element._id) }} style={{ color: (element.admin_blocked ? "#0F993E" : "#ff4c27") }}>
//                                                     <Block />
//                                                 </button> */}
//                                                 {/* <button className='delete' onClick={() => setMainId(element._id)} data-bs-toggle="modal" data-bs-target="#decline_modal">
//                                                     <Delete />
//                                                 </button> */}
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 ))
//                             }
//                             {!loading && all.length <= 0 && <NoDataRow />}

//                             {loading && <LoadingRow />}
//                             {total > limit && <tr className='text-center'><td colSpan={20}><Pagination handlePageClick={handlePageClick} totalCount={total} limit={limit} /></td></tr>}

//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </>
//     )
// }
